import { Button } from "ui/components/button";
import { PermissionGate } from "permissions/components/gate";
import HeaderPortal from "components/portal/header-portal";
import React from "react";
import { useCreatePerformanceReview } from "./mutations";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { eventBus } from "utils/eventBus";
import EmployeeInput from "components/employee/input";
import CreateItemButton from "components/buttons/create";

const PerformanceReviewInputSheet = ({ reviews }) => {
  const [selectedReviewees, setSelectedReviewees] = useState([]);

  const { quadId, employeeId } = useParams();
  const { mutate: createPerformanceReview } = useCreatePerformanceReview({
    onSuccess: () => {
      eventBus.emit(
        "refresh:list",
        `performance_reviewreviewer-performance-reviews-${employeeId}-${quadId}`,
      );
    },
  });

  const handleConfirm = () => {
    if (selectedReviewees.length > 0 && quadId && employeeId) {
      selectedReviewees.forEach((reviewee) => {
        createPerformanceReview({
          quadrimester: quadId,
          revieweeId: reviewee.id,
          reviewerId: employeeId,
        });
      });
    }
  };

  function renderFooter({ setOpen }) {
    return (
      <Button
        onClick={() => {
          handleConfirm();
          setSelectedReviewees([]);
          setOpen(false);
        }}
      >
        Assign Reviewees
      </Button>
    );
  }

  const filters = {
    id: {
      _nin:
        reviews?.length > 0
          ? [employeeId, ...reviews.map((item) => item.id)]
          : [employeeId],
    },
  };

  return (
    <>
      <HeaderPortal>
        <PermissionGate
          rule="create:*"
          collection="performance_review"
          // showWhenDisabled={false}
        >
          <EmployeeInput
            multiselect={true}
            value={selectedReviewees}
            onChange={setSelectedReviewees}
            allowRemoval={true}
            footer={renderFooter}
            excludedEmployeeIds={[
              ...(reviews?.map((item) => item.reviewee.id) || []),
              ...selectedReviewees.map((emp) => emp.id),
            ]}
            filters={filters}
          >
            <CreateItemButton>Reviewee</CreateItemButton>
          </EmployeeInput>
        </PermissionGate>
      </HeaderPortal>
    </>
  );
};

export default PerformanceReviewInputSheet;
